import { render, staticRenderFns } from "./EventsCampaignCreate.vue?vue&type=template&id=83a54d36&"
import script from "./EventsCampaignCreate.vue?vue&type=script&lang=js&"
export * from "./EventsCampaignCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports